// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c103ef15","977":"eba65025"}[chunkId] + ".chunk.js";
};